import src from "IMAGE";
export default { src, width: 604, height: 60, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ACYnJio0NDQtMzIvK0hDPTsxMTAmPj49MBk6Kj4KSx9aZaAGUySh30EAAAAASUVORK5CYII="};
